import { useQuery } from "@tanstack/react-query";
import { getContent } from "../lib/api";

export function useContent(name) {
  return useQuery({
    queryKey: ["content", name],
    queryFn: () => getContent(name),
    staleTime: 60_000,
  });
}
